<template>
    <div class="content-loader" :class="`content-loader--${contentType}`">
        <div class="content-loader__left">
            <div class="content-loader__bar content-loader__bar--headline"></div>
            <div class="content-loader__bar content-loader__bar--headline"></div>
        </div>
        <div class="content-loader__right">
            <div class="content-loader__bar content-loader__bar--button"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contentType: {
            default: 'route',
            type: String
        }
    }
}
</script>

<style lang="scss">
.content-loader {
    $block: &;

    padding-top: 25px;
    padding-bottom: 25px;
    display: flex;

    &__left {
        flex-grow: 1;
    }

    &__bar {
        animation-duration: 1.25s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: placeHolderShimmer;
        animation-timing-function: linear;
        background: $color-black-01;
        background: linear-gradient(to right, $color-black-01 5%, $color-black-005 36%, $color-black-01 70%);
        background-size: 900px 104px;
        position: relative;
        border-radius: 6px;

        &--headline {
            height: 24px;

            &:not(:last-child) {
                margin-bottom: 3px;
            }

            &:first-child {
                max-width: 160px;
            }
            &:nth-child(2) {
                max-width: 230px;
            }
        }

        &--button {
            height: 40px;
            width: 65px;
            margin-left: 10px;
        }
    }
}

@keyframes placeHolderShimmer{
    0%{
        background-position: -468px 0
    }
    100%{
        background-position: 468px 0
    }
}
</style>